import React from "react";
import { Button, ButtonToolbar, Modal } from "react-bootstrap";

export function EditCityModal({
  isLoadingEditCity,
  handleEditHide,
  isEditModal,
  data,
  stateList,
  formikEditCity,
  onClickOfCancelButton,
}) {
  const { name } = data;

  return (
    <>
      <Modal
        show={isEditModal}
        onHide={handleEditHide}
        dialogClassName="modal-90w"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        closeButton
      >
        <Modal.Header closeButton>
          <Modal.Title> {`Edit City - ${name}`}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-0">
          <form
            onSubmit={formikEditCity.handleSubmit}
            onReset={formikEditCity.handleReset}
          >
            <div className="row">
              <div className="col-md-6 mb-6">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {`City Name`}
                </h5>
                <input
                  type="text"
                  className="form-control form-control-solid form-control-solid-brand h-40px"
                  placeholder="State"
                  name="name"
                  {...formikEditCity.getFieldProps("name")}
                />
                {formikEditCity.touched.name && formikEditCity.errors.name ? (
                  <div className="invalid-feedback display-block">
                    {formikEditCity.errors.name}
                  </div>
                ) : null}
              </div>

              <div className="col-md-6 mb-6">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {`Select Status`}
                </h5>
                <select
                  className="form-control form-control-solid form-control-solid-brand h-40px is-valid-select"
                  name="status"
                  {...formikEditCity.getFieldProps("status")}
                >
                  <option value="1">Active</option>
                  <option value="0">Deactive</option>
                </select>
                {formikEditCity.touched.status &&
                formikEditCity.errors.status ? (
                  <div className="invalid-feedback display-block">
                    {formikEditCity.errors.status}
                  </div>
                ) : null}
              </div>

              <div className="col-md-6 mb-6">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {`Select State`}
                </h5>
                <select
                  className="form-control form-control-solid form-control-solid-brand h-40px is-valid-select"
                  name="state_name"
                  {...formikEditCity.getFieldProps("state_name")}
                >
                  {stateList.map((state, index) => (
                    <option value={state.state_name} key={index}>
                      {state.state_name}
                    </option>
                  ))}
                </select>
                {formikEditCity.touched.state_name &&
                formikEditCity.errors.state_name ? (
                  <div className="invalid-feedback display-block">
                    {formikEditCity.errors.state_name}
                  </div>
                ) : null}
              </div>
            </div>

            <ButtonToolbar className="d-flex justify-content-end button-wrap mb-8">
              <Button
                type="submit"
                disabled={formikEditCity.isSubmitting}
                variant="btn btn-success mr-3"
              >
                {`Edit`}
                {isLoadingEditCity && (
                  <span className=" mr-3 ml-3 spinner spinner-white"></span>
                )}
              </Button>
              <Button
                type="reset"
                variant="btn btn-light-dark"
                onClick={onClickOfCancelButton}
              >
                {`Cancel`}
              </Button>
            </ButtonToolbar>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}
